import { FormattedMessage } from 'react-intl'
import * as Styles from '../ShareWithDropdown.styles'

export const NoOptionsMessage = () => (
  <Styles.NoResults>
    <FormattedMessage id="general.noMatchesFound" />
  </Styles.NoResults>
)
